import { render } from "./ResultsChart.vue?vue&type=template&id=faf332ac&scoped=true"
import script from "./ResultsChart.vue?vue&type=script&lang=js"
export * from "./ResultsChart.vue?vue&type=script&lang=js"

import "./ResultsChart.vue?vue&type=style&index=0&id=faf332ac&scoped=true&lang=css"
import "./ResultsChart.vue?vue&type=style&index=1&id=faf332ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf332ac"]])

export default __exports__